module.exports = __webpack_public_path__ + "static/media/fsc1.78d903b6.svg";